import { SymptomData } from './types';

export const symptomData: SymptomData[] = [
  { name: "One-sided Weakness", value: 100 }, 
  { name: "Severe Headache", value: 90 },
  { name: "Visual Changes", value: 85 }, 
  { name: "Numbness/Tingling", value: 80 },
  { name: "Speech Difficulties", value: 75 },
  { name: "Nausea", value: 70 },
  { name: "Light Sensitivity", value: 65 }
];

export const ageData: SymptomData[] = [
  { name: "Childhood (5-12)", value: 25 },
  { name: "Teens (13-19)", value: 30 },
  { name: "Young Adults (20-29)", value: 20 },
  { name: "Adults (30-39)", value: 15 },
  { name: "40+", value: 10 }
];

export const sourcesData = {
  title: "Data Sources",
  sources: [
    {
      name: "StatPearls - Hemiplegic Migraine",
      description: "Authoritative medical textbook reference",
      url: "https://www.ncbi.nlm.nih.gov/books/NBK513302/"
    },
    {
      name: "American Migraine Foundation", 
      description: "Expert clinical guidance on hemiplegic migraine",
      url: "https://americanmigrainefoundation.org/resource-library/hemiplegic-migraine/"
    },
    {
      name: "MedlinePlus Genetics",
      description: "NIH database on sporadic hemiplegic migraine",
      url: "https://medlineplus.gov/genetics/condition/sporadic-hemiplegic-migraine/"
    },
    {
      name: "NORD - Hemiplegic Migraine",
      description: "National Organization for Rare Disorders clinical overview",
      url: "https://rarediseases.org/rare-diseases/hemiplegic-migraine/"
    },
    {
      name: "Diagnostic and Therapeutic Aspects of Hemiplegic Migraine",
      description: "Peer-reviewed clinical study on epidemiology and symptoms",
      url: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7361005/"
    }
  ]
};